webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tradeinfo__ = __webpack_require__(104);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* default */],
    tradeinfo: __WEBPACK_IMPORTED_MODULE_4__tradeinfo__["a" /* default */]
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_auth__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_auth__);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    authenticating: false,
    error: null,
    user: null
  },
  mutations: {
    setAuthenticating: function setAuthenticating(state, payload) {
      // console.log('setAuthenticating', payload)
      state.authenticating = payload;
    },
    setError: function setError(state, payload) {
      // console.log('setError', payload)
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    clearError: function clearError(context) {
      context.commit('clearError');
    },
    signUserIn: function signUserIn(context, _ref) {
      var mode = _ref.mode,
          providerName = _ref.providerName,
          email = _ref.email,
          password = _ref.password;

      context.commit('setAuthenticating', true);
      context.commit('clearError');
      var authProvider = void 0;
      switch (providerName) {
        case 'google':
          authProvider = new __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth.GoogleAuthProvider();
          break;
        case 'facebook':
          authProvider = new __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth.FacebookAuthProvider();
          break;
        case 'github':
          authProvider = new __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth.GithubAuthProvider();
          break;
        case 'twitter':
          authProvider = new __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth.TwitterAuthProvider();
          break;
      }
      var promise = void 0;
      if (authProvider) {
        promise = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth().signInWithPopup(authProvider);
      } else {
        if (mode === 'signin') {
          promise = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth().signInWithEmailAndPassword(email, password);
        } else {
          promise = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth().createUserWithEmailAndPassword(email, password);
        }
      }
      return promise.then(function (user) {
        context.commit('setAuthenticating', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        context.commit('setUser', newUser);
      }).catch(function (error) {
        context.commit('setAuthenticating', false);
        context.commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(context, payload) {
      context.commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
    },
    logout: function logout(context) {
      __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth().signOut();
      context.commit('setUser', null);
    }
  },
  getters: {
    userIsAuthenticated: function userIsAuthenticated(state) {
      return state.user !== null && state.user !== undefined;
    }
  }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isDevelopment: "production" === 'development'
  },
  mutations: {},
  actions: {},
  getters: {
    isDevelopment: function isDevelopment(state) {
      return state.isDevelopment;
    }
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__firebase_app__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__firebase_firestore__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__firebase_functions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__firebase_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__firebase_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__utils__);















var ErrorPricesInvalid = function (_Error) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(ErrorPricesInvalid, _Error);

  function ErrorPricesInvalid(message, invalidPrices) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ErrorPricesInvalid);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ErrorPricesInvalid.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ErrorPricesInvalid)).call(this, message));

    _this.invalidPrices = invalidPrices;
    return _this;
  }

  return ErrorPricesInvalid;
}(Error);

var DEPLOYMENT_ID = __WEBPACK_IMPORTED_MODULE_13__utils__["isProduction"]() ? 'production' : 'test';
var ROOT = '/deployments/' + DEPLOYMENT_ID;
var FIELD_TIMESTAMPED = 'timestamped';
var FIELD_TIMESTAMP = 'timestamp';
var MOCK_SAVING = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    offline: false,
    persistenceError: null,
    initializing: true,
    initialized: false,
    saving: false,
    itemCategoriesMap: {},
    itemCategoriesList: [],
    itemsMap: {},
    itemsList: [],
    anchorsMap: {},
    anchorsList: [],
    locationsMap: {},
    locationsList: [],
    locationsItemsPricesMap: {},
    locationsItemsPricesMetadataMap: {},
    buySellRatiosFilter: {
      items: [],
      anchorsBuy: [],
      locationsBuy: [],
      anchorsSell: [],
      locationsSell: []
    },
    buySellRatiosPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: 'ratio',
      rowsPerPageItems: [5, 10, 25, 50, 100]
    },
    buySellRatiosPaginationOld: {},
    buySellRatiosUnsubscribes: [],
    buySellRatiosResponseCount: 0,
    buySellRatiosAll: [],
    buySellRatiosFiltered: []
  },
  mutations: {
    setOffline: function setOffline(state, payload) {
      // console.log('setOffline', payload)
      var offline = payload;
      // console.log('setOffline offline', offline)
      state.offline = offline;
    },
    _setPersistenceError: function _setPersistenceError(state, payload) {
      state.persistenceError = payload;
    },
    _setInitialized: function _setInitialized(state) {
      // console.log('_setInitialized')
      state.initializing = false;
      state.initialized = true;
    },
    _setSaving: function _setSaving(state, payload) {
      // console.log('_setSaving', payload)
      state.saving = payload;
    },
    _addItemCategory: function _addItemCategory(state, payload) {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.itemCategoriesMap, payload.id, payload);
      state.itemCategoriesList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.itemCategoriesMap).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    _addItem: function _addItem(state, payload) {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.itemsMap, payload.id, payload);
      state.itemsList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.itemsMap).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    _addAnchor: function _addAnchor(state, payload) {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.anchorsMap, payload.id, payload);
      state.anchorsList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.anchorsMap).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    _addLocation: function _addLocation(state, payload) {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.locationsMap, payload.id, payload);
      state.locationsList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.locationsMap).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    _setLocationItemPrices: function _setLocationItemPrices(state, _ref) {
      var locationId = _ref.locationId,
          locationItemPrices = _ref.locationItemPrices,
          metadata = _ref.metadata;

      var locationItemPricesList = state.itemsList.map(function (item) {
        // console.log('item', item)

        var itemId = item.id;
        var itemName = item.name;
        var itemCategory = item.category;
        var locationItemPrice = locationItemPrices[itemId];
        // console.log('locationItemPrice', locationItemPrice)

        locationItemPrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
          id: itemId,
          name: itemName,
          category: itemCategory
        }, locationItemPrice);
        // console.log('locationItemPrice', locationItemPrice)

        var priceBuy = locationItemPrice.priceBuy;
        var priceSell = locationItemPrice.priceSell;
        var isPriceDefined = !isNaN(priceBuy) || !isNaN(priceSell);
        locationItemPrice.isPriceDefined = isPriceDefined;

        return locationItemPrice;
      });
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.locationsItemsPricesMap, locationId, locationItemPricesList);
      if (metadata) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.locationsItemsPricesMetadataMap, locationId, metadata);
      } else {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(state.locationsItemsPricesMetadataMap, locationId, undefined);
      }
    },
    _setLocationItemPriceInvalid: function _setLocationItemPriceInvalid(state, _ref2) {
      var locationId = _ref2.locationId,
          itemId = _ref2.itemId,
          buyOrSell = _ref2.buyOrSell,
          invalidPrice = _ref2.invalidPrice;

      var locationItemPrices = state.locationsItemsPricesMap[locationId];
      // console.log('_setLocationItemPriceInvalid locationItemPrices', locationItemPrices)
      var prices = locationItemPrices.find(function (item) {
        return item.id === itemId;
      });
      // console.log('_setLocationItemPriceInvalid itemPrices', itemPrices)
      var errorKey = 'invalidPrice' + __WEBPACK_IMPORTED_MODULE_13__utils__["uppercaseFirstLetter"](buyOrSell);
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(prices, errorKey, invalidPrice);
    },
    _setBuySellRatiosFilter: function _setBuySellRatiosFilter(state, payload) {
      // console.log('_setBuySellRatiosFilter payload', payload)
      state.buySellRatiosFilter = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, payload);
    },
    _setBuySellRatiosPagination: function _setBuySellRatiosPagination(state, payload) {
      // console.log('_setBuySellRatiosPagination payload', payload)
      state.buySellRatiosPaginationOld = state.buySellRatiosPagination;
      state.buySellRatiosPagination = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, payload);
    },
    _clearBuySellRatios: function _clearBuySellRatios(state) {
      state.buySellRatiosUnsubscribes.splice(0);
      state.buySellRatiosResponseCount = 0;
      state.buySellRatiosAll.splice(0);
      state.buySellRatiosFiltered.splice(0);
    },
    _addBuySellRatiosUnsubscribe: function _addBuySellRatiosUnsubscribe(state, payload) {
      state.buySellRatiosUnsubscribes.push(payload);
    },
    _incrementBuySellRatiosResponseCount: function _incrementBuySellRatiosResponseCount(state) {
      state.buySellRatiosResponseCount++;
    },
    _setBuySellRatio: function _setBuySellRatio(state, _ref3) {
      var id = _ref3.id,
          buySellRatio = _ref3.buySellRatio;

      // console.log('_setBuySellRatio id', id, 'buySellRatio', JSON.stringify(buySellRatio))
      // console.log('_setBuySellRatio BEFORE state.buySellRatiosAll', JSON.stringify(state.buySellRatiosAll))
      var foundIndex = state.buySellRatiosAll.findIndex(function (buySellRatio) {
        return buySellRatio.id === id;
      });
      if (foundIndex !== -1) {
        // console.log('_setBuySellRatio Remove item...')
        state.buySellRatiosAll.splice(foundIndex, 1);
      }
      if (buySellRatio) {
        // console.log('_setBuySellRatio Add item...')
        state.buySellRatiosAll.push(buySellRatio);
      }

      var buySellRatiosPagination = state.buySellRatiosPagination;
      // console.log('_setBuySellRatio buySellRatiosPagination', buySellRatiosPagination)
      var sortBy = buySellRatiosPagination.sortBy,
          descending = buySellRatiosPagination.descending,
          rowsPerPage = buySellRatiosPagination.rowsPerPage;

      state.buySellRatiosAll.sort(function (a, b) {
        var valueA = a[sortBy];
        var valueB = b[sortBy];
        var result = void 0;
        if (valueA > valueB) {
          result = 1;
        } else if (valueA < valueB) {
          result = -1;
        } else {
          result = 0;
        }
        if (descending) {
          result = -result;
        }
        return result;
      });
      // console.log('_setBuySellRatio AFTER state.buySellRatiosAll', JSON.stringify(state.buySellRatiosAll))

      state.buySellRatiosFiltered = state.buySellRatiosAll.slice(0, rowsPerPage);
    }
  },
  actions: {
    initialize: function initialize(context) {
      // console.log('initialize')

      context.dispatch('_queryItemCategories');
    },
    _queryItemCategories: function _queryItemCategories(context) {
      // console.log('_queryItemCategories')
      var path = ROOT + '/itemCategories';
      // console.log('_queryItemCategories path', path)
      __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.firestore().collection(path).onSnapshot( /* { includeMetadataChanges: true }, */function (querySnapshot) {
        context.dispatch('_onQueriedItemCategories', querySnapshot);
      }, function (error) {
        console.error('_queryItemCategories', error);
      });
    },
    _onQueriedItemCategories: function _onQueriedItemCategories(context, querySnapshot) {
      var docChanges = querySnapshot.docChanges();
      // console.log('_onQueriedItemCategories docChanges', docChanges)
      if (docChanges.length === 0) {
        // console.warn('_onQueriedItemCategories docChanges.length === 0 ignoring')
        return;
      }
      // console.log('_onQueriedItemCategories')
      docChanges.forEach(function (change) {
        // console.log('_onQueriedItemCategories change.type', change.type)
        var doc = change.doc;
        // console.log('_onQueriedItemCategories doc', doc)
        var itemCategoryId = doc.id;
        // const fromCache = doc.metadata.fromCache
        // console.log('_onQueriedItemCategories ' + itemCategoryId + ' fromCache', fromCache)
        if ( // !fromCache ||
        context.state.itemCategoriesMap[itemCategoryId] === undefined) {
          var docData = doc.data();
          // console.log(docData)
          if (docData.name !== undefined) {
            var itemCategory = {
              id: itemCategoryId,
              name: docData.name
              // console.log('itemCategory.name:' + itemCategory.name)
            };context.commit('_addItemCategory', itemCategory);
          }
        }
      });

      if (context.state.itemsList.length === 0) {
        context.dispatch('_queryItems');
      }
    },
    _queryItems: function _queryItems(context) {
      // console.log('_queryItems')
      var path = ROOT + '/itemTypes';
      // console.log('_queryItems path', path)
      __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.firestore().collection(path).onSnapshot( /* { includeMetadataChanges: true }, */function (querySnapshot) {
        context.dispatch('_onQueriedItems', querySnapshot);
      }, function (error) {
        console.error('_queryItems', error);
      });
    },
    _onQueriedItems: function _onQueriedItems(context, querySnapshot) {
      var docChanges = querySnapshot.docChanges();
      // console.log('_onQueriedItems docChanges', docChanges)
      if (docChanges.length === 0) {
        // console.warn('_onQueriedItems docChanges.length === 0 ignoring')
        return;
      }
      // console.log('_onQueriedItems')
      docChanges.forEach(function (change) {
        // console.log('_onQueriedItems change.type', change.type)
        var doc = change.doc;
        // console.log('_onQueriedItems doc', doc)
        var itemId = doc.id;
        // const fromCache = doc.metadata.fromCache
        // console.log('_onQueriedItems ' + itemId + ' fromCache', fromCache)
        if ( // !fromCache ||
        context.state.itemsMap[itemId] === undefined) {
          var docData = doc.data();
          // console.log(docData)
          if (docData.name !== undefined) {
            var itemCategoryId = docData.category.id;
            var item = {
              id: itemId,
              name: docData.name,
              category: context.state.itemCategoriesMap[itemCategoryId].name
            };
            if (docData.illegal) {
              item.illegal = true;
            }
            // console.log('item.name:' + item.name)
            context.commit('_addItem', item);
          }
        }
      });

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(context.state.anchorsMap).length === 0) {
        context.dispatch('_queryAnchors');
      }
    },
    _queryAnchors: function _queryAnchors(context) {
      // console.log('_queryAnchors')
      var path = ROOT + '/anchors';
      // console.log('_queryAnchors path', path)
      __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.firestore().collection(path).onSnapshot( /* { includeMetadataChanges: true }, */function (querySnapshot) {
        context.dispatch('_onQueriedAnchors', querySnapshot);
      }, function (error) {
        console.error('_queryAnchors', error);
      });
    },
    _onQueriedAnchors: function _onQueriedAnchors(context, querySnapshot) {
      var docChanges = querySnapshot.docChanges();
      // console.log('_onQueriedAnchors docChanges', docChanges)
      if (docChanges.length === 0) {
        // console.warn('_onQueriedAnchors docChanges.length === 0 ignoring')
        return;
      }
      // console.log('_onQueriedAnchors')
      docChanges.forEach(function (change) {
        // console.log('_onQueriedAnchors change.type', change.type)
        var doc = change.doc;
        // console.log('_onQueriedAnchors doc', doc)
        var anchorId = doc.id;
        // const fromCache = doc.metadata.fromCache
        // console.log('_onQueriedAnchors ' + anchorId + ' fromCache', fromCache)
        if ( // !fromCache ||
        context.state.anchorsMap[anchorId] === undefined) {
          var docData = doc.data();
          // console.log('_onQueriedAnchors docData', docData)
          var anchor = {
            id: anchorId,
            name: docData.name,
            type: docData.type.id,
            anchor: docData.anchor !== undefined ? docData.anchor.id : undefined
            // console.log('anchor.name:' + anchor.name)
          };context.commit('_addAnchor', anchor);
        }
      });

      if (context.state.locationsList.length === 0) {
        context.dispatch('_queryLocations');
      }
    },
    _queryLocations: function _queryLocations(context) {
      // console.log('_queryLocations')
      var path = ROOT + '/locations';
      // console.log('_queryLocations path', path)
      __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.firestore().collection(path).onSnapshot( /* { includeMetadataChanges: true }, */function (querySnapshot) {
        context.dispatch('_onQueriedLocations', querySnapshot);
      }, function (error) {
        console.error('_queryLocations', error);
      });
    },
    _onQueriedLocations: function _onQueriedLocations(context, querySnapshot) {
      var docChanges = querySnapshot.docChanges();
      // console.log('_onQueriedLocations docChanges', docChanges)
      if (docChanges.length === 0) {
        // console.warn('_onQueriedLocations docChanges.length === 0 ignoring')
        return;
      }
      // console.log('_onQueriedLocations')
      docChanges.forEach(function (change) {
        // console.log('_onQueriedLocations change.type', change.type)
        var doc = change.doc;
        // console.log('_onQueriedLocations doc', doc)
        var locationId = doc.id;
        // const fromCache = doc.metadata.fromCache
        // console.log('_onQueriedLocations ' + locationId + ' fromCache', fromCache)
        if ( // !fromCache ||
        context.state.locationsMap[locationId] === undefined) {
          var docData = doc.data();
          // console.log(docData)

          var location = {
            id: locationId,
            name: docData.name,
            anchor: context.state.anchorsMap[docData.anchor.id],
            // locationType: docData.type,
            prices: {}
            // console.log('location.name:' + location.name)
          };context.commit('_addLocation', location);

          context.dispatch('_queryLocationItemPrices', locationId);
        }
      });
    },
    _queryLocationItemPrices: function _queryLocationItemPrices(context, locationId) {
      // console.log('_queryLocationItemPrices locationId', locationId)
      var path = ROOT + '/locations/' + locationId + '/prices';
      // console.log('_queryLocationItemPrices path', path)
      __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.firestore().collection(path).where(FIELD_TIMESTAMPED, '==', true).orderBy(FIELD_TIMESTAMP, 'desc').limit(1).onSnapshot( /* { includeMetadataChanges: true }, */function (querySnapshot) {
        context.dispatch('_onQueriedLocationItemPrices', { locationId: locationId, querySnapshot: querySnapshot });
      }, function (error) {
        console.error('_queryLocationItemPrices', error);
        context.commit('_setLocationItemPrices', { locationId: locationId, locationItemPrices: undefined });
        context.dispatch('_testIfInitialized');
      });
    },
    _onQueriedLocationItemPrices: function _onQueriedLocationItemPrices(context, _ref4) {
      var locationId = _ref4.locationId,
          querySnapshot = _ref4.querySnapshot;

      // const path = `${ROOT}/locations/${locationId}/prices`
      // console.log('_onQueriedLocationItemPrices path', path)
      var docChanges = querySnapshot.docChanges();
      // console.log('_onQueriedLocationItemPrices docChanges', docChanges)
      if (docChanges.length === 0 && context.state.locationsItemsPricesMap[locationId] !== undefined) {
        // console.warn('_onQueriedLocationItemPrices ' + path + ' docChanges.length === 0 ignoring')
        return;
      }
      var locationItemPrices = {};
      var metadata = {};
      docChanges.forEach(function (change) {
        // console.log('_onQueriedLocationItemPrices change.type', change.type)
        if (change.type === 'removed' && docChanges.length !== 1) {
          return;
        }
        var doc = change.doc;
        // console.log('_onQueriedLocationItemPrices doc', doc)
        // const fromCache = doc.metadata.fromCache
        // console.log('_onQueriedLocationItemPrices fromCache', fromCache)
        var docData = doc.data();
        // console.log('_onQueriedLocationItemPrices docData', docData)
        var docDataTimestamp = docData[FIELD_TIMESTAMP];
        metadata.timestamp = docDataTimestamp && docDataTimestamp.toDate();
        metadata.userId = docData.userId;
        var prices = docData.prices;
        // console.log('_onQueriedLocationItemPrices prices', prices)
        if (prices) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(prices).forEach(function (itemId) {
            var locationItemPrice = prices[itemId];
            var thisPrices = {};

            var locationItemPriceBuy = locationItemPrice.priceBuy;
            if (locationItemPriceBuy && !isNaN(locationItemPriceBuy)) {
              thisPrices.priceBuy = Number(locationItemPriceBuy);
            }

            var locationItemPriceSell = locationItemPrice.priceSell;
            if (locationItemPriceSell && !isNaN(locationItemPriceSell)) {
              thisPrices.priceSell = Number(locationItemPriceSell);
            }

            locationItemPrices[itemId] = thisPrices;
          });
        }
      });
      // console.log('_onQueriedLocationItemPrices locationItemPrices', locationItemPrices)
      context.commit('_setLocationItemPrices', { locationId: locationId, locationItemPrices: locationItemPrices, metadata: metadata });

      context.dispatch('_testIfInitialized');
    },
    _testIfInitialized: function _testIfInitialized(context) {
      if (!context.state.initialized && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(context.state.locationsItemsPricesMap).length === context.state.locationsList.length) {
        //
        // Only _setInitialized when *ALL* _queryLocationItemPrices have come back
        //
        // console.info('%c_testIfInitialized INITIALIZED!', 'color: green;')
        context.commit('_setInitialized');

        if (context.state.buySellRatiosAll.length === 0) {
          context.dispatch('queryBuySellRatios');
        }
      }
    },
    setBuySellRatiosFilter: function setBuySellRatiosFilter(context, payload) {
      // console.log('setBuySellRatiosFilter _setBuySellRatiosFilter && queryBuySellRatios')
      context.commit('_setBuySellRatiosFilter', payload);
      context.dispatch('queryBuySellRatios');
    },
    setBuySellRatiosPagination: function setBuySellRatiosPagination(context, payload) {
      //
      // Prevent double queryBuySellRatios...
      //
      var buySellRatiosPaginationOld = context.state.buySellRatiosPaginationOld;
      if (payload.sortBy !== buySellRatiosPaginationOld.sortBy || payload.descending !== buySellRatiosPaginationOld.descending || payload.rowsPerPage !== buySellRatiosPaginationOld.rowsPerPage || payload.page !== buySellRatiosPaginationOld.page) {
        // console.log('setBuySellRatiosPagination buySellRatiosPagination changed; _setBuySellRatiosPagination && queryBuySellRatios')
        context.commit('_setBuySellRatiosPagination', payload);
        context.dispatch('queryBuySellRatios');
      } else {
        // console.log('setBuySellRatiosPagination buySellRatiosPagination unchanged; ignore')
      }
    },
    queryBuySellRatios: function queryBuySellRatios(context) {
      // console.info('queryBuySellRatios')
      if (!context.state.initialized) {
        // console.log('queryBuySellRatios initialized == false; ignoring')
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(context.state.buySellRatiosUnsubscribes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var buySellRatiosUnsubscribe = _step.value;

          // console.log('queryBuySellRatios buySellRatiosUnsubscribe()')
          buySellRatiosUnsubscribe();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      context.commit('_clearBuySellRatios');

      //
      // https://vuetifyjs.com/en/components/data-tables#example-server
      // https://github.com/vuetifyjs/vuetify/blob/master/src/mixins/data-iterable.js#L27
      //
      var buySellRatiosPagination = context.state.buySellRatiosPagination;
      // console.log('queryBuySellRatios buySellRatiosPagination', buySellRatiosPagination)
      var sortBy = buySellRatiosPagination.sortBy,
          descending = buySellRatiosPagination.descending,
          rowsPerPage = buySellRatiosPagination.rowsPerPage;

      var direction = descending ? 'desc' : 'asc';
      var path = ROOT + '/buySellRatios';

      var firestore = __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.firestore();

      var queries = [];

      var buySellRatiosFilter = context.state.buySellRatiosFilter;
      // console.log('queryBuySellRatios buySellRatiosFilter', buySellRatiosFilter)
      buySellRatiosFilter.items.forEach(function (filterItem) {
        var query = firestore.collection(path).where('itemName', '==', filterItem.name);
        if (sortBy !== 'itemName') {
          query = query.orderBy(sortBy, direction);
        }
        queries.push(query);
      });
      buySellRatiosFilter.anchorsBuy.forEach(function (filterAnchor) {
        var query = firestore.collection(path).where('anchorsBuyName', '==', filterAnchor.name);
        if (sortBy !== 'anchorsBuyName') {
          query = query.orderBy(sortBy, direction);
        }
        queries.push(query);
      });
      buySellRatiosFilter.locationsBuy.forEach(function (filterLocationBuy) {
        var query = firestore.collection(path).where('buyLocationName', '==', filterLocationBuy.name);
        if (sortBy !== 'buyLocationName') {
          query = query.orderBy(sortBy, direction);
        }
        queries.push(query);
      });
      buySellRatiosFilter.anchorsSell.forEach(function (filterAnchor) {
        var query = firestore.collection(path).where('anchorsSellName', '==', filterAnchor.name);
        if (sortBy !== 'anchorsSellName') {
          query = query.orderBy(sortBy, direction);
        }
        queries.push(query);
      });
      buySellRatiosFilter.locationsSell.forEach(function (filterLocationSell) {
        var query = firestore.collection(path).where('sellLocationName', '==', filterLocationSell.name);
        if (sortBy !== 'sellLocationName') {
          query = query.orderBy(sortBy, direction);
        }
        queries.push(query);
      });
      if (!queries.length) {
        var query = firestore.collection(path).orderBy(sortBy, direction);
        queries.push(query);
      }
      // console.log('queryBuySellRatios queries', queries)

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(queries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _query2 = _step2.value;

          _query2 = _query2.limit(rowsPerPage);
          // console.log('queryBuySellRatios query', getQueryString(query))
          var _buySellRatiosUnsubscribe = _query2.onSnapshot({ includeMetadataChanges: true }, function (querySnapshot) {
            context.dispatch('_onQueriedBuySellRatios', querySnapshot);
          }, function (error) {
            console.error('queryBuySellRatios', error);
          });
          context.commit('_addBuySellRatiosUnsubscribe', _buySellRatiosUnsubscribe);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    _onQueriedBuySellRatios: function _onQueriedBuySellRatios(context, querySnapshot) {
      // console.log('_onQueriedBuySellRatios querySnapshot', querySnapshot)
      var docChanges = querySnapshot.docChanges();
      // console.log('_onQueriedBuySellRatios docChanges', docChanges)
      if (docChanges.length === 0) {
        // console.warn('_onQueriedBuySellRatios docChanges.length === 0 ignoring')
        return;
      }
      // console.log('_onQueriedBuySellRatios')

      docChanges.forEach(function (change) {
        // console.log('_onQueriedBuySellRatios change', change)
        var changeType = change.type;
        // console.log('_onQueriedBuySellRatios changeType', changeType)
        var doc = change.doc;
        // console.log('_onQueriedBuySellRatios doc', doc)
        var docId = doc.id;
        // const fromCache = doc.metadata.fromCache
        // console.log('_onQueriedBuySellRatios ' + docId + ' fromCache', fromCache)
        var buySellRatio = void 0;
        if (changeType === 'removed') {
          buySellRatio = null;
        } else {
          var docData = doc.data();
          // console.log('_onQueriedBuySellRatios docData', docData)

          var itemId = docData.itemId;
          var itemName = context.state.itemsMap[itemId].name;
          var buyLocationId = docData.buyLocationId;
          // console.log('_onQueriedBuySellRatios buyLocationId', buyLocationId)
          var buyLocationName = context.state.locationsMap[buyLocationId].name;
          var buyPrice = docData.buyPrice;
          var buyTimestamp = docData.buyTimestamp;
          var ratio = docData.ratio;
          var sellPrice = docData.sellPrice;
          var sellTimestamp = docData.sellTimestamp;
          var sellLocationId = docData.sellLocationId;
          // console.log('_onQueriedBuySellRatios sellLocationId', sellLocationId)
          var sellLocationName = context.state.locationsMap[sellLocationId].name;

          buySellRatio = {
            id: docId,
            itemId: itemId,
            itemName: itemName,
            buyLocationId: buyLocationId,
            buyLocationName: buyLocationName,
            buyPrice: buyPrice,
            buyTimestamp: buyTimestamp && buyTimestamp.toDate(),
            ratio: ratio,
            sellPrice: sellPrice,
            sellTimestamp: sellTimestamp && sellTimestamp.toDate(),
            sellLocationId: sellLocationId,
            sellLocationName: sellLocationName
          };
        }
        // console.log('_onQueriedBuySellRatios buySellRatio', buySellRatio)
        context.commit('_setBuySellRatio', { id: docId, buySellRatio: buySellRatio });
      });
      context.commit('_incrementBuySellRatiosResponseCount');
    },
    saveLocationItemPrices: function saveLocationItemPrices(context, _ref5) {
      var locationId = _ref5.locationId,
          locationItemPrices = _ref5.locationItemPrices;

      // console.log('saveLocationItemPrices locationId:', locationId)
      // console.log('saveLocationItemPrices locationItemPrices:', locationItemPrices)

      var user = context.rootState.user.user;
      // console.log('saveLocationItemPrices user', user)
      var userId = user && user.id;
      // console.log('saveLocationItemPrices userId', userId)
      if (!userId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Not authenticated'));
      }

      var prices = {};

      var changed = false;

      var mapPricesNew = {};
      locationItemPrices.forEach(function (item) {
        mapPricesNew[item.id] = item;
      });
      // console.log('saveLocationItemPrices mapPricesNew', mapPricesNew)

      var invalidPrices = [];

      var arrayPricesOriginalAll = context.state.locationsItemsPricesMap[locationId];
      // console.log('saveLocationItemPrices arrayPricesOriginalAll', arrayPricesOriginalAll)
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(arrayPricesOriginalAll), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var priceOriginal = _step3.value;

          // console.log('saveLocationItemPrices priceOriginal', priceOriginal)
          var itemId = priceOriginal.id;
          var priceOriginalBuy = priceOriginal.priceBuy;
          var priceOriginalSell = priceOriginal.priceSell;
          // console.log('saveLocationItemPrices priceOriginalBuy', priceOriginalBuy, 'priceOriginalSell', priceOriginalSell)
          var priceNew = mapPricesNew[itemId];
          // console.log('saveLocationItemPrices priceNew', priceNew)
          var priceNewBuy = void 0;
          var priceNewSell = void 0;
          if (priceNew) {
            var invalidPrice = void 0;

            priceNewBuy = priceNew.priceBuy;
            // console.log('saveLocationItemPrices priceNewBuy', priceNewBuy)
            if (priceNewBuy === null) {
              priceNewBuy = priceOriginalBuy;
            }
            invalidPrice = priceNewBuy && isNaN(priceNewBuy);
            context.commit('_setLocationItemPriceInvalid', { locationId: locationId, itemId: itemId, buyOrSell: 'buy', invalidPrice: invalidPrice });
            if (invalidPrice) {
              invalidPrices.push({ itemId: itemId, buyOrSell: 'buy' });
            } else {
              priceNewBuy = Number(priceNewBuy);
            }

            priceNewSell = priceNew.priceSell;
            // console.log('saveLocationItemPrices priceNewSell', priceNewSell)
            if (priceNewSell === null) {
              priceNewSell = priceOriginalSell;
            }
            invalidPrice = priceNewSell && isNaN(priceNewSell);
            context.commit('_setLocationItemPriceInvalid', { locationId: locationId, itemId: itemId, buyOrSell: 'sell', invalidPrice: invalidPrice });
            if (invalidPrice) {
              invalidPrices.push({ itemId: itemId, buyOrSell: 'sell' });
            } else {
              priceNewSell = Number(priceNewSell);
            }
          }
          // console.log('saveLocationItemPrices priceNewBuy', priceNewBuy, 'priceNewSell', priceNewSell)

          if (invalidPrices.length) {
            continue;
          }

          var thisPrices = {};
          changed |= priceOriginalBuy !== priceNewBuy;
          if (priceNewBuy) {
            thisPrices.priceBuy = priceNewBuy;
          }
          changed |= priceOriginalSell !== priceNewSell;
          if (priceNewSell) {
            thisPrices.priceSell = priceNewSell;
          }
          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(thisPrices).length > 0) {
            prices[itemId] = thisPrices;
          }
        }
        // console.log('saveLocationItemPrices prices', prices)
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (invalidPrices.length) {
        var message = 'Invalid price';
        if (invalidPrices.length === 1) {
          message += 's';
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new ErrorPricesInvalid(message, invalidPrices));
      }

      if (!changed) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('No prices changed'));
      }

      var data = {
        deploymentId: DEPLOYMENT_ID,
        locationId: locationId
      };
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(prices).length) {
        data.prices = prices;
      }
      if (false || MOCK_SAVING) {
        console.log('saveLocationItemPrices data', data);
      }
      context.commit('_setSaving', true);
      if (MOCK_SAVING) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          setTimeout(function () {
            context.commit('_setSaving', false);
            resolve({ mocked: true });
          }, 5000);
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_10__firebase_app___default.a.functions().httpsCallable('addLocationPrice')(data).then(function (result) {
          // console.log('addLocationPrice result', result)
          context.commit('_setSaving', false);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        }, function (error) {
          console.error('addLocationPrice ERROR', error);
          context.commit('_setSaving', false);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
      }
    }
  },
  getters: {
    saveable: function saveable(state, getters, rootState) {
      return getters.userIsAuthenticated && (MOCK_SAVING || !getters.offline) && !state.saving;
    },
    itemCategory: function itemCategory(state) {
      return function (itemCategoryId) {
        return state.itemCategoriesMap[itemCategoryId].name;
      };
    },
    items: function items(state) {
      return state.itemsList;
    },
    anchors: function anchors(state) {
      return state.anchorsList;
    },
    locations: function locations(state) {
      return state.locationsList;
    },
    location: function location(state) {
      return function (locationId) {
        return state.locationsMap[locationId];
      };
    },
    locationItemPriceList: function locationItemPriceList(state) {
      return function (locationId) {
        return state.locationsItemsPricesMap[locationId];
      };
    },
    locationItemPriceMetadata: function locationItemPriceMetadata(state) {
      return function (locationId) {
        return state.locationsItemsPricesMetadataMap[locationId];
      };
    },
    buySellRatiosFilter: function buySellRatiosFilter(state) {
      return state.buySellRatiosFilter;
    },
    buySellRatiosPagination: function buySellRatiosPagination(state) {
      return state.buySellRatiosPagination;
    },
    hasBuySellRatios: function hasBuySellRatios(state) {
      var buySellRatiosUnsubscribesLength = state.buySellRatiosUnsubscribes.length;
      // console.log('hasBuySellRatios state.initialized', state.initialized)
      // console.log('hasBuySellRatios state.buySellRatiosUnsubscribes.length', buySellRatiosUnsubscribesLength)
      // console.log('hasBuySellRatios state.buySellRatiosResponseCount', state.buySellRatiosResponseCount)
      var hasBuySellRatios = state.initialized && buySellRatiosUnsubscribesLength && buySellRatiosUnsubscribesLength === state.buySellRatiosResponseCount;
      // console.log('hasBuySellRatios', hasBuySellRatios)
      return hasBuySellRatios;
    }
  }

  // eslint-disable-next-line no-unused-vars
});function getQueryString(query) {
  // console.log('getQueryString query', query)

  var queryString = '';

  var _query = query._query;

  var path = _query.path;
  queryString = 'path ' + path;

  var where = _query.filters;
  if (where.length) {
    queryString += ' where ' + where;
  }

  var orderBy = _query.explicitOrderBy;
  if (orderBy.length) {
    queryString += ' orderBy ' + orderBy;
  }

  var limit = _query.limit;
  if (limit) {
    queryString += ' limit ' + limit;
  }

  // offset

  return queryString;
}

/*
function buySellRatiosEqual(a, b) {
  // console.log('equals a', a, 'b', b)
  let result = a.itemName === b.itemName
  // console.log('equals itemName', result)
  result = result && a.buyLocationName === b.buyLocationName
  // console.log('equals buyLocationName', result)
  result = result && a.buyPrice === b.buyPrice
  // console.log('equals buyPrice', result)
  // NOTE:(pv) For some reason comparing buyTimestamp returns false
  result = result && a.ratio === b.ratio
  // console.log('equals ratio', result)
  result = result && a.sellPrice === b.sellPrice
  // console.log('equals sellPrice', result)
  // NOTE:(pv) For some reason comparing sellTimestamp returns false
  result = result && a.sellLocationName === b.sellLocationName
  // console.log('equals sellLocationName', result)
  return result
}
*/

/*
function concatUniqueSortLimit (arrayA, arrayB, equals, sort, limit) {
  const result = arrayA.concat(arrayB)
  for (var i = 0; i < result.length; ++i) {
    for (var j = i + 1; j < result.length; ++j) {
      if (equals(result[i], result[j])) {
        result.splice(j--, 1)
      }
    }
  }
  result.sort(sort)
  return result.slice(0, limit)
}
*/

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {


function isDevelopment() {
  return "production" !== 'production';
}

function isProduction() {
  return "production" === 'production';
}

function formatDateYMDHMS(date) {
  if (date) {
    date = date.getFullYear() + '/' + lpad(date.getMonth() + 1, 2) + '/' + lpad(date.getDate(), 2) + ' ' + lpad(date.getHours(), 2) + ':' + lpad(date.getMinutes(), 2) + ':' + lpad(date.getSeconds(), 2) + '.' + lpad(date.getMilliseconds(), 3);
  }
  return date;
}

function lpad(value, width) {
  return value.toString().length > width ? value : (new Array(width).join('0') + value).slice(-width);
}

function uppercaseFirstLetter(text) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

module.exports = {
  isDevelopment: isDevelopment,
  isProduction: isProduction,
  formatDateYMDHMS: formatDateYMDHMS,
  lpad: lpad,
  uppercaseFirstLetter: uppercaseFirstLetter
};

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false,
      title: 'Trade Citizen',
      editing: false,
      progressHeight: 4,
      toast: {
        show: false,
        message: null,
        timeoutMillis: 3000
      }
    };
  },
  created: function created() {
    // console.log('App created')
  },
  mounted: function mounted() {
    // console.log('App mounted')
    var vm = this;
    window.addEventListener('load', function () {
      vm.updateOnlineStatus();
      window.addEventListener('online', vm.updateOnlineStatus);
      window.addEventListener('offline', vm.updateOnlineStatus);
      window.addEventListener('keydown', vm.onKeyDown);
    });
    vm.$root.$on('toastMessage', function (payload) {
      // console.log('App vm.toastMessage payload', payload)
      vm.toastMessage(payload);
    });
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('App beforeDestroy')
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    isDevelopment: function isDevelopment(state) {
      return state.shared.isDevelopment;
    },
    authenticating: function authenticating(state) {
      return state.user.authenticating;
    },
    offline: function offline(state) {
      return state.tradeinfo.offline;
    },
    initializing: function initializing(state) {
      return state.tradeinfo.initializing;
    },
    saving: function saving(state) {
      return state.tradeinfo.saving;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['userIsAuthenticated', 'saveable']), {
    showProgress: function showProgress() {
      return this.authenticating || this.initializing || this.saving;
    },

    locationId: {
      get: function get() {
        // Example(s):
        //  http://localhost:8080/?locationId=zsrxhjHzhfXxUCPs73EF
        var locationId = this.$route.query.locationId;
        // console.log('App locationId this.$route.query.locationId', locationId)
        return locationId;
      },
      set: function set(value) {
        var location = { path: '/', query: value ? { locationId: value } : null
          // console.log(`App locationId set this.$router.push(${location})`)
        };this.$router.push(location);
      }
    },
    showEdit: function showEdit() {
      if (!this.locationId) {
        return false;
      }
      var locationItemPriceList = this.$store.getters.locationItemPriceList(this.locationId);
      var accumulator = 0;
      if (locationItemPriceList) {
        accumulator = locationItemPriceList.reduce(function (accumulator, locationItemPrice) {
          if (locationItemPrice.isPriceDefined) {
            accumulator++;
          }
          return accumulator;
        }, accumulator);
      }
      return accumulator > 0;
    },
    locations: function locations() {
      var _this = this;

      return this.$store.getters.locations.map(function (location) {
        var id = location.id;
        var name = location.anchor.name + ' - ' + location.name;
        if (_this.isDevelopment) {
          name += ' {' + id + '}';
        }
        return {
          id: id,
          name: name
        };
      }).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    locationItemPriceTimestamp: function locationItemPriceTimestamp() {
      var metadata = this.$store.getters.locationItemPriceMetadata(this.locationId);
      var timestamp = metadata && metadata.timestamp;
      // console.log('timestamp', timestamp)
      timestamp = __WEBPACK_IMPORTED_MODULE_3__utils__["formatDateYMDHMS"](timestamp);
      if (!timestamp) {
        timestamp = 'Never';
      }
      return timestamp;
    }
  }),

  watch: {
    locationId: {
      handler: function handler() {
        // console.log('App watch locationId')
        this.editing = false;
      }
    }
  },

  methods: {
    updateOnlineStatus: function updateOnlineStatus() {
      var online = navigator.onLine;
      // console.log('App updateOnlineStatus online', online)
      this.$store.commit('setOffline', !online);
    },
    onKeyDown: function onKeyDown(event) {
      // NOTE: metaKey == Command on Mac
      if ((event.metaKey || event.ctrlKey) && event.keyCode === 'S'.charCodeAt(0)) {
        event.preventDefault();
        this.saveLocation();
      }
    },
    toastMessage: function toastMessage(payload) {
      this.toast = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ show: true }, payload);
    },
    signin: function signin() {
      this.editing = false;
      this.$router.push('/signin');
    },
    signout: function signout() {
      this.editing = false;
      this.$store.dispatch('logout');
      this.home();
    },
    home: function home() {
      this.$router.push('/');
    },
    editLocation: function editLocation(editing) {
      // console.log('App editLocation editing', editing)
      this.editing = editing;
      this.$root.$emit('editLocation', this.locationId, this.editing);
    },
    saveLocation: function saveLocation() {
      // console.log('App saveLocation this.locationId', this.locationId)
      if (!this.locationId || !this.saveable) {
        return;
      }
      this.editLocation(false);
      this.$root.$emit('saveLocation', this.locationId);
    }
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// TODO:(pv) When ready for production, remove FEATURE_FILTER_ANCHOR and consolidate HEADERS direcly in to data
var FEATURE_FILTER_ANCHOR = false;
var HEADERS = [];
HEADERS.push({ sortable: true, align: 'right', text: 'Item', value: 'itemName' });
if (FEATURE_FILTER_ANCHOR) {
  HEADERS.push({ sortable: true, align: 'right', text: 'Buy Anchor', value: 'buyAnchorName' });
}
HEADERS.push({ sortable: true, align: 'right', text: 'Buy Location', value: 'buyLocationName' });
HEADERS.push({ sortable: true, align: 'right', text: 'Buy Price', value: 'buyPrice' });
HEADERS.push({ sortable: true, align: 'center', text: 'Ratio', value: 'ratio' });
HEADERS.push({ sortable: true, align: 'left', text: 'Sell Price', value: 'sellPrice' });
if (FEATURE_FILTER_ANCHOR) {
  HEADERS.push({ sortable: true, align: 'left', text: 'Sell Anchor', value: 'sellAnchorName' });
}
HEADERS.push({ sortable: true, align: 'left', text: 'Sell Location', value: 'sellLocationName' });

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      FEATURE_FILTER_ANCHOR: FEATURE_FILTER_ANCHOR,
      headers: HEADERS,
      buySellRatiosFilter: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.getters.buySellRatiosFilter),
      buySellRatiosPagination: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.getters.buySellRatiosPagination),
      locationItemPriceListCopy: [],
      editing: false
    };
  },
  created: function created() {
    // console.log('Home created')
    this.updateLocationItemPriceListCopy();
  },
  mounted: function mounted() {
    // console.log('Home mounted')
    var vm = this;
    vm.$root.$on('editLocation', function (locationId, editing) {
      // console.log('Home vm.editLocation locationId:' + locationId)
      vm.editLocation(locationId, editing);
    });
    vm.$root.$on('saveLocation', function (locationId) {
      // console.log('Home vm.saveLocation locationId:' + locationId)
      vm.saveLocation(locationId);
    });
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    isDevelopment: function isDevelopment(state) {
      return state.shared.isDevelopment;
    },
    persistenceError: function persistenceError(state) {
      return state.tradeinfo.persistenceError;
    },
    initialized: function initialized(state) {
      return state.tradeinfo.initialized;
    },
    saving: function saving(state) {
      return state.tradeinfo.saving;
    },
    buySellRatiosFiltered: function buySellRatiosFiltered(state) {
      return state.tradeinfo.buySellRatiosFiltered;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['userIsAuthenticated', 'saveable', 'hasBuySellRatios']), {
    locationId: {
      get: function get() {
        // Example(s):
        //  http://localhost:8080/?locationId=zsrxhjHzhfXxUCPs73EF
        var locationId = this.$route.query.locationId;
        // console.log('Home locationId this.$route.query.locationId', locationId)
        return locationId;
      }
    },
    items: function items() {
      return this.$store.getters.items.map(function (item) {
        // if (item.illegal && !this.buySellRatiosFilter.illegal) {
        //   return
        // }
        var id = item.id;
        var name = item.name;
        /*
        if (this.isDevelopment) {
          name += ' {' + id + '}'
        }
        */
        return { id: id, name: name };
      }).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    anchors: function anchors() {
      return this.$store.getters.anchors;
    },
    locations: function locations() {
      return this.$store.getters.locations.map(function (location) {
        var id = location.id;
        var name = location.name;
        // name = location.anchor.name + ' - ' + name
        /*
        if (this.isDevelopment) {
          name += ' {' + id + '}'
        }
        */
        return { id: id, name: name };
      }).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
    },
    locationItemPriceList: function locationItemPriceList() {
      return this.$store.getters.locationItemPriceList(this.locationId);
    }
  }),

  watch: {
    persistenceError: {
      handler: function handler() {
        this.onPersistenceError();
      }
    },
    locationId: {
      handler: function handler() {
        // console.log('Home watch locationId')
        this.editing = false;
      }
    },
    buySellRatiosPagination: {
      deep: true,
      handler: function handler(value) {
        this.$store.dispatch('setBuySellRatiosPagination', value);
      }
    },
    buySellRatiosFilter: {
      deep: true,
      handler: function handler(value) {
        this.$store.dispatch('setBuySellRatiosFilter', value);
      }
    },
    locationItemPriceList: {
      deep: true,
      handler: function handler() {
        // console.log('Home watch locationItemPriceList')
        this.updateLocationItemPriceListCopy();
      }
    },
    editing: {
      handler: function handler() {
        // console.log('Home watch editing')
        this.updateLocationItemPriceListCopy();
      }
    }
  },

  methods: {
    getLocationRoute: function getLocationRoute(locationId, itemId) {
      var path = '/';
      var query = {};
      if (locationId) {
        query.locationId = locationId;
      }
      if (itemId) {
        path += '#' + itemId;
      }
      var route = { path: path, query: query
        // console.log('getLocationRoute locationId', locationId, 'itemId', itemId, 'route', route)
      };return route;
    },
    getItemBorder: function getItemBorder() {
      return 'border:1px solid white; border-radius:6px;';
    },
    toastMessage: function toastMessage(payload) {
      this.$root.$emit('toastMessage', payload);
    },
    onPersistenceError: function onPersistenceError() {
      // console.log('Home onPersistenceError error', error)
      var error = this.persistenceError;
      if (!error) {
        return;
      }
      var toastMessage = void 0;
      if (error.code === 'failed-precondition') {
        toastMessage = 'Multiple tabs open; Offline mode disabled.';
      } else if (error.code === 'unimplemented') {
        toastMessage = 'Offline mode not supported.';
      } else {
        if (error.message) {
          toastMessage = error.message;
        } else {
          toastMessage = 'Offline mode disabled: "' + error.code + '"';
        }
      }
      this.toastMessage({ message: toastMessage });
    },
    formatDateYMDHMS: function formatDateYMDHMS(date) {
      return __WEBPACK_IMPORTED_MODULE_3__utils__["formatDateYMDHMS"](date);
    },
    refresh: function refresh() {
      // console.log('Home refresh()')
      if (!this.buySellRatiosFilter.illegal) {
        // Clear illegal items from this.buySellRatiosFilter.items
        var items = this.$store.getters.items;
        var i = this.buySellRatiosFilter.items.length;
        while (i--) {
          var item = this.buySellRatiosFilter.items[i];
          if (items[item.id].illegal) {
            this.buySellRatiosFilter.item.splice(i, 1);
          }
        }
      }
    },
    updateLocationItemPriceListCopy: function updateLocationItemPriceListCopy() {
      var _this = this;

      // console.log('Home updateLocationItemPriceListCopy')
      if (this.saving) {
        // console.log('Home updateLocationItemPriceListCopy saving')
        //
        // We're saving new values.
        // Don't update with the soon to be old values.
        // Do hide any blank/0 valued items.
        //
        var i = this.locationItemPriceListCopy.length;
        // console.log('Home updateLocationItemPriceListCopy this.locationItemPriceListCopy.length', i)
        while (i--) {
          var itemPrice = this.locationItemPriceListCopy[i];
          // console.log('updateLocationItemPriceListCopy itemPrice', JSON.stringify(itemPrice))
          if ((itemPrice.priceBuy === 0 || itemPrice.priceBuy === undefined) && (itemPrice.priceSell === 0 || itemPrice.priceSell === undefined)) {
            this.locationItemPriceListCopy.splice(i, 1);
          }
        }
      } else {
        // console.log('Home updateLocationItemPriceListCopy *NOT* saving')
        this.locationItemPriceListCopy.splice(0);
        var prices = this.locationItemPriceList;
        // console.log('Home updateLocationItemPriceListCopy prices BEFORE', prices)
        if (prices && !this.editing) {
          var pricesDefined = prices.filter(function (price) {
            return price.isPriceDefined;
          });
          // console.log('Home updateLocationItemPriceListCopy pricesDefined', pricesDefined)
          if (pricesDefined.length > 0 || !this.userIsAuthenticated) {
            // console.log('Home updateLocationItemPriceListCopy A')
            prices = pricesDefined;
          } else {
            // console.log('Home updateLocationItemPriceListCopy B')
          }
        } else {}
          // console.log('Home updateLocationItemPriceListCopy C')

          // console.log('Home updateLocationItemPriceListCopy prices AFTER', prices)
        if (prices) {
          prices.forEach(function (price) {
            var copy = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, price);
            _this.locationItemPriceListCopy.push(copy);
          });
        }
      }
      // console.log('Home updateLocationItemPriceListCopy AFTER this.locationItemPriceListCopy', JSON.stringify(this.locationItemPriceListCopy))
    },
    editLocation: function editLocation(locationId, editing) {
      // console.log('Home editLocation locationId:' + locationId)
      // console.log('Home editLocation editing:' + editing)
      this.editing = editing;
    },
    saveLocation: function saveLocation(locationId) {
      var _this2 = this;

      // console.log('Home saveLocation this.locationId:' + this.locationId)
      // console.log('Home saveLocation this.locationItemPriceListCopy', this.locationItemPriceListCopy)
      this.$store.dispatch('saveLocationItemPrices', {
        locationId: this.locationId,
        locationItemPrices: this.locationItemPriceListCopy
      }).then(function (result) {
        // console.log('Home saveLocation SUCCESS!')
        _this2.editing = false;
        var message = 'Prices Saved.';
        if (result && result.mocked) {
          message = 'Mock ' + message;
        }
        _this2.toastMessage({ message: message });
      }).catch(function (error) {
        // console.log('Home saveLocation ERROR', error)
        var toastMessage = error.message ? error.message : error;
        _this2.toastMessage({ message: toastMessage });
      });
    }
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var util = __webpack_require__(96);

var textSignIn = 'Sign in';
var textSignUp = 'Sign up';
var buttonTextSignInFormat = 'Sign in with %s';
var buttonTextSignUpFormat = 'Sign up with %s';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      showButtons: {
        'generic': true,
        'google': true,
        'facebook': false,
        'github': false,
        'twitter': false
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    user: function user(state) {
      return state.user.user;
    },
    error: function error(state) {
      return state.user.error;
    },
    authenticating: function authenticating(state) {
      return state.user.authenticating;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])([]), {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : '';
    }
  }),

  watch: {
    user: function user(value) {
      // console.log('watch user', value)
      if (value !== null && value !== undefined) {
        // console.log('router push /')
        this.$router.push('/');
      }
    }
  },

  methods: {
    routePath: function routePath() {
      return this.$route.path;
    },
    isSignIn: function isSignIn() {
      return this.routePath() === '/signin';
    },
    formatButtonText: function formatButtonText(providerName) {
      var buttonText = void 0;
      if (providerName) {
        var format = this.isSignIn() ? buttonTextSignInFormat : buttonTextSignUpFormat;
        buttonText = util.format(format, providerName);
      } else {
        buttonText = this.isSignIn() ? textSignIn : textSignUp;
      }
      return buttonText;
    },
    signUserIn: function signUserIn(providerName) {
      this.showOnly(providerName);
      this.$store.dispatch('signUserIn', {
        mode: this.isSignIn() ? 'signin' : 'signup',
        providerName: providerName,
        email: this.email,
        password: this.password
      });
    },
    onDismissed: function onDismissed() {
      this.showOnly(null);
      this.$store.dispatch('clearError');
    },
    showOnly: function showOnly(providerName) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.showButtons).forEach(function (buttonName) {
        var show = !providerName || buttonName === providerName;
        // console.log('showOnly buttonName', buttonName, 'show', show)
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this.showButtons, buttonName, show);
      });
    }
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_util_colors__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase_app__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase_firestore__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_roboto_fontface_css_roboto_roboto_fontface_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_roboto_fontface_css_roboto_roboto_fontface_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_roboto_fontface_css_roboto_roboto_fontface_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_design_icons_iconfont_dist_material_design_icons_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// Required for roboto & material-design-icons fonts to work offline


// TODO:(pv) Include http://fontawesome.io/icons/ and https://materialdesignicons.com/
//  https://next.vuetifyjs.com/components/icons#examples

// Used in App.vue to show app version in footer
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$PACKAGE_VERSION = "0.2.1";

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    //
    // https://github.com/vuetifyjs/vuetify/blob/master/src/stylus/settings/_colors.styl
    //
    primary: __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_util_colors___default.a.cyan.lighten2
    // secondary: '#424242',
    // accent: '#82B1FF',
    // error: '#FF5252',
    // info: '#2196F3',
    // success: '#4CAF50',
    // warning: '#FFC107'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_6__firebase_app___default.a.initializeApp({
  apiKey: 'AIzaSyDfKA77M6vyodG8_BprKviSgNtB0zLoVDU',
  authDomain: 'trade-citizen.firebaseapp.com',
  projectId: 'trade-citizen'
});
var firestore = __WEBPACK_IMPORTED_MODULE_6__firebase_app___default.a.firestore();
firestore.settings({
  timestampsInSnapshots: true
});

// eslint-disable-next-line no-new
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] },
  created: function created() {
    var _this = this;

    // console.log('Vue created')
    firestore.enablePersistence().then(function (result) {
      // console.log('Vue enablePersistence resolve')
    }, function (reason) {
      // console.warn('Vue enablePersistence reject', reason)
      _this.$store.commit('_setPersistenceError', reason);
    }).then(function (result) {
      _this.$store.dispatch('initialize');
    });
    __WEBPACK_IMPORTED_MODULE_6__firebase_app___default.a.auth().onAuthStateChanged(function (user) {
      // console.log('Vue onAuthStateChanged user', user)
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
      }
    });
  },
  mounted: function mounted() {
    // console.log('Vue mounted')
    var vm = this;
    window.addEventListener('load', function () {
      vm.updateNetworkStatus();
      window.addEventListener('online', vm.updateNetworkStatus);
      window.addEventListener('offline', vm.updateNetworkStatus);
    });
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('Vue beforeDestroy')
    window.removeEventListener('online', this.updateNetworkStatus);
    window.removeEventListener('offline', this.updateNetworkStatus);
  },

  methods: {
    updateNetworkStatus: function updateNetworkStatus() {
      var offline = !navigator.onLine;
      // console.log('Vue updateNetworkStatus offline', offline)
      if (offline) {
        // console.log('Vue updateNetworkStatus firestore.disableNetwork()')
        firestore.disableNetwork();
      } else {
        // console.log('Vue updateNetworkStatus firestore.enableNetwork()')
        firestore.enableNetwork();
      }
      this.$store.commit('setOffline', offline);
    }
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19425076_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(40);
function injectStyle (context) {
  __webpack_require__(80)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19425076_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19425076_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('v-navigation-drawer',{attrs:{"app":"","fixed":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',{attrs:{"to":"/"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Home")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"https://bitbucket.org/trade-citizen/trade-citizen/issues/new","target":"_blank"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("bug_report")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Report a bug")])],1)],1),_vm._v(" "),(_vm.userIsAuthenticated)?[_c('v-list-tile',{on:{"click":_vm.signout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Sign out")])],1)]:[_c('v-list-tile',{on:{"click":_vm.signin}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("lock_open")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Sign in")])],1)]],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":"","extended":_vm.showProgress,"extension-height":_vm.progressHeight}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0 mr-2",staticStyle:{"cursor":"pointer"},attrs:{"tag":"span"},on:{"click":_vm.home}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.$route.path==='/signin')?[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"flat":"","to":"/signup"}},[_c('v-icon',{staticClass:"mx-1"},[_vm._v("face")]),_vm._v("\n        Sign up\n      ")],1)]:(_vm.$route.path==='/signup')?[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"flat":"","to":"/signin"}},[_c('v-icon',{staticClass:"mx-1"},[_vm._v("lock_open")]),_vm._v("\n        Sign in\n      ")],1)]:(_vm.$route.path==='/')?[_c('v-select',{staticClass:"mx-2",attrs:{"append-icon":"search","placeholder":"Search","solo-inverted":"","auto":"","autocomplete":"","clearable":"","disabled":this.showProgress,"dense":_vm.$vuetify.breakpoint.xsOnly,"items":_vm.locations,"item-text":"name","item-value":"id"},model:{value:(_vm.locationId),callback:function ($$v) {_vm.locationId=$$v},expression:"locationId"}}),_vm._v(" "),(_vm.locationId)?[(_vm.userIsAuthenticated)?[(_vm.showEdit)?[(_vm.editing)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"icon":""},on:{"click":function($event){return _vm.editLocation(false)}}},[_c('v-icon',{staticClass:"mx-1"},[_vm._v("cancel")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Cancel Edit Prices")])]):_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"icon":"","disabled":!_vm.saveable},on:{"click":function($event){return _vm.editLocation(true)}}},[_c('v-icon',{staticClass:"mx-1"},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Edit Prices")])])]:_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"icon":"","disabled":!_vm.saveable},on:{"click":_vm.saveLocation}},[_c('v-icon',{staticClass:"mx-1"},[_vm._v("save")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s('Save Prices (' + (_vm.offline ? 'OFFLINE' : 'Control-S or ⌘-S') + ')'))])])]:[_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"flat":"","disabled":_vm.offline},on:{"click":_vm.signin}},[_c('v-icon',{staticClass:"mx-1"},[_vm._v("lock_open")]),_vm._v("\n            Sign in\n          ")],1)]]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.showProgress)?_c('v-progress-linear',{staticClass:"ma-0",attrs:{"slot":"extension","height":_vm.progressHeight,"indeterminate":true},slot:"extension"}):_vm._e()],2),_vm._v(" "),_c('v-content',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3",attrs:{"app":""}},[(_vm.locationId)?_c('div',[_vm._v("\n      Priced at: "+_vm._s(_vm.locationItemPriceTimestamp)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.offline ? 'OFFLINE' : ''))]),_vm._v(" "),_c('div',{staticClass:"pl-2"},[_vm._v("v"+_vm._s(_vm.$PACKAGE_VERSION)+" © 2018")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.toast.timeoutMillis,"bottom":""},model:{value:(_vm.toast.show),callback:function ($$v) {_vm.$set(_vm.toast, "show", $$v)},expression:"toast.show"}},[_vm._v("\n    "+_vm._s(_vm.toast.message)+"\n    "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.toast.show = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_User_Signin__ = __webpack_require__(93);



// import Profile from '@/components/User/Profile'

// import AuthGuard from './auth-guard'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  },
  /*
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter: AuthGuard
  },
  */
  {
    path: '/signup',
    name: 'Sign up',
    component: __WEBPACK_IMPORTED_MODULE_3__components_User_Signin__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Sign in',
    component: __WEBPACK_IMPORTED_MODULE_3__components_User_Signin__["a" /* default */]
  }]
}));

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe43f0a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(40);
function injectStyle (context) {
  __webpack_require__(91)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fe43f0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe43f0a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe43f0a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.locationId == null)?_c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","d-flex":"","align-center":""}},[_c('v-select',{attrs:{"label":"Item","clearable":"","multiple":"","single-line":"","hide-details":"","hide-selected":"","dense":"","items":_vm.items,"item-value":"id","item-text":"name","return-object":""},model:{value:(_vm.buySellRatiosFilter.items),callback:function ($$v) {_vm.$set(_vm.buySellRatiosFilter, "items", $$v)},expression:"buySellRatiosFilter.items"}}),_vm._v(" "),(_vm.FEATURE_FILTER_ANCHOR)?_c('v-select',{attrs:{"label":"Buy Anchor","clearable":"","multiple":"","single-line":"","hide-details":"","hide-selected":"","dense":"","items":_vm.anchors,"item-value":"id","item-text":"name","return-object":""},model:{value:(_vm.buySellRatiosFilter.anchorsBuy),callback:function ($$v) {_vm.$set(_vm.buySellRatiosFilter, "anchorsBuy", $$v)},expression:"buySellRatiosFilter.anchorsBuy"}}):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"label":"Buy Location","clearable":"","multiple":"","single-line":"","hide-details":"","hide-selected":"","dense":"","items":_vm.locations,"item-value":"id","item-text":"name","return-object":""},model:{value:(_vm.buySellRatiosFilter.locationsBuy),callback:function ($$v) {_vm.$set(_vm.buySellRatiosFilter, "locationsBuy", $$v)},expression:"buySellRatiosFilter.locationsBuy"}}),_vm._v(" "),(_vm.FEATURE_FILTER_ANCHOR)?_c('v-select',{attrs:{"label":"Sell Anchor","clearable":"","multiple":"","single-line":"","hide-details":"","hide-selected":"","dense":"","items":_vm.anchors,"item-value":"id","item-text":"name","return-object":""},model:{value:(_vm.buySellRatiosFilter.anchorsSell),callback:function ($$v) {_vm.$set(_vm.buySellRatiosFilter, "anchorsSell", $$v)},expression:"buySellRatiosFilter.anchorsSell"}}):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"label":"Sell Location","clearable":"","multiple":"","single-line":"","hide-details":"","hide-selected":"","dense":"","items":_vm.locations,"item-value":"id","item-text":"name","return-object":""},model:{value:(_vm.buySellRatiosFilter.locationsSell),callback:function ($$v) {_vm.$set(_vm.buySellRatiosFilter, "locationsSell", $$v)},expression:"buySellRatiosFilter.locationsSell"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","d-flex":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"must-sort":"","sort-icon":"arrow_downward","hide-actions":!_vm.hasBuySellRatios,"no-data-text":_vm.hasBuySellRatios ? 'No data available' : 'Loading...',"headers":_vm.headers,"pagination":_vm.buySellRatiosPagination,"rows-per-page-items":_vm.buySellRatiosPagination.rowsPerPageItems,"rows-per-page-text":"Max Results","items":_vm.buySellRatiosFiltered},on:{"update:pagination":function($event){_vm.buySellRatiosPagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.itemName))]),_vm._v(" "),(_vm.FEATURE_FILTER_ANCHOR)?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n          "+_vm._s(props.item.buyAnchorName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('router-link',{attrs:{"to":_vm.getLocationRoute(props.item.buyLocationId)}},[_vm._v("\n            "+_vm._s(props.item.buyLocationName)+"\n          ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('router-link',{attrs:{"to":_vm.getLocationRoute(props.item.buyLocationId, props.item.itemId)}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(props.item.buyPrice.toFixed(3)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDateYMDHMS(props.item.buyTimestamp)))])])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.ratio.toFixed(3)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('router-link',{attrs:{"to":_vm.getLocationRoute(props.item.sellLocationId, props.item.itemId)}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(props.item.sellPrice.toFixed(3)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDateYMDHMS(props.item.sellTimestamp)))])])],1)],1),_vm._v(" "),(_vm.FEATURE_FILTER_ANCHOR)?_c('td',{staticClass:"text-xs-left"},[_vm._v("\n          "+_vm._s(props.item.sellAnchorName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('router-link',{attrs:{"to":_vm.getLocationRoute(props.item.sellLocationId)}},[_vm._v("\n            "+_vm._s(props.item.sellLocationName)+"\n          ")])],1)]}}],null,false,2272942091)})],1)],1):_c('v-container',{staticClass:"pa-0",attrs:{"grid-list-md":"","fluid":""}},[(_vm.initialized && _vm.locationItemPriceListCopy.length)?_c('v-layout',{staticClass:"pa-2",attrs:{"row":"","wrap":""}},_vm._l((_vm.locationItemPriceListCopy),function(locationItemPrice,index){return _c('v-flex',{key:locationItemPrice.id,attrs:{"xs4":""}},[_c('v-card',{style:(_vm.getItemBorder()),attrs:{"id":locationItemPrice.id}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-title',{staticClass:"px-0 py-0",attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline"},[_vm._v(_vm._s(locationItemPrice.name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(locationItemPrice.category))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-number-field',{staticClass:"input-group--focused inputPrice",attrs:{"label":"Buy Price","autofocus":index === 0,"color":_vm.saveable ? 'cyan lighten-2' : '',"disabled":!_vm.saveable,"clearable":_vm.saveable,"clearValue":locationItemPrice.priceBuy === 0 ? null : 0,"hide-details":!locationItemPrice.invalidPriceBuy,"error-messages":locationItemPrice.invalidPriceBuy ? 'Invalid price' : undefined},on:{"input":function($event){locationItemPrice.invalidPriceBuy = false},"click":function($event){return $event.target.select()}},model:{value:(locationItemPrice.priceBuy),callback:function ($$v) {_vm.$set(locationItemPrice, "priceBuy", _vm._n($$v))},expression:"locationItemPrice.priceBuy"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-number-field',{staticClass:"input-group--focused inputPrice",attrs:{"label":"Sell Price","color":_vm.saveable ? 'cyan lighten-2' : '',"disabled":!_vm.saveable,"clearable":_vm.saveable,"clearValue":locationItemPrice.priceSell === 0 ? null : 0,"hide-details":!locationItemPrice.invalidPriceSell,"error-messages":locationItemPrice.invalidPriceSell ? 'Invalid price' : undefined},on:{"input":function($event){locationItemPrice.invalidPriceSell = false},"click":function($event){return $event.target.select()}},model:{value:(locationItemPrice.priceSell),callback:function ($$v) {_vm.$set(locationItemPrice, "priceSell", _vm._n($$v))},expression:"locationItemPrice.priceSell"}})],1)],1)],1)],1)],1)}),1):_c('v-layout',{attrs:{"justify-center":""}},[_c('p',{staticClass:"pa-4"},[_vm._v(_vm._s(_vm.initialized ? 'No prices set' : 'Loading...'))])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b873cc3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(40);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b873cc3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b873cc3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.signUserIn('generic')}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","required":"","disabled":_vm.authenticating},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":"","disabled":_vm.authenticating},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),(_vm.$route.path==='/signup')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","rules":[_vm.comparePasswords],"disabled":_vm.authenticating},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-center"},[(_vm.showButtons['generic'])?_c('v-btn',{attrs:{"type":"submit","round":"","disabled":_vm.authenticating}},[_vm._v(_vm._s(_vm.formatButtonText())+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock_open")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(_vm.showButtons['google'])?_c('v-btn',{staticClass:"red",attrs:{"round":"","disabled":_vm.authenticating},on:{"click":function($event){$event.preventDefault();return _vm.signUserIn('google')}}},[_vm._v(_vm._s(_vm.formatButtonText('Google'))+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock_open")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(_vm.showButtons['facebook'])?_c('v-btn',{attrs:{"round":"","disabled":_vm.authenticating},on:{"click":function($event){$event.preventDefault();return _vm.signUserIn('facebook')}}},[_vm._v(_vm._s(_vm.formatButtonText('Facebook'))+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock_open")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(_vm.showButtons['github'])?_c('v-btn',{attrs:{"round":"","disabled":_vm.authenticating},on:{"click":function($event){$event.preventDefault();return _vm.signUserIn('github')}}},[_vm._v(_vm._s(_vm.formatButtonText('GitHub'))+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock_open")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(_vm.showButtons['twitter'])?_c('v-btn',{attrs:{"round":"","disabled":_vm.authenticating},on:{"click":function($event){$event.preventDefault();return _vm.signUserIn('twitter')}}},[_vm._v(_vm._s(_vm.formatButtonText('Twitter'))+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock_open")])],1):_vm._e()],1)])],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ })

},[74]);


// WEBPACK FOOTER //
// static/js/app.034f8bc33e6f918adea7.js